export const COMPLETED = 'COMPLETED';
export const DISPUTED = 'DISPUTED';
export const EXPIRED = 'EXPIRED';
export const MANUAL = 'MANUAL';
export const NEW = 'NEW';
export const PAYABLE = 'PAYABLE';
export const PENDING = 'PENDING';
export const REJECTED = 'REJECTED';
export const RETURNED = 'RETURNED';

export const STATUS = {
    COMPLETED,
    DISPUTED,
    EXPIRED,
    MANUAL,
    NEW,
    PAYABLE,
    PENDING,
    REJECTED,
    RETURNED,
};
